import { useState } from "react";

export const InlinePrice = ({ value, bold, rule, onSave, testid }) => {
  const [edit, setEdit] = useState(false);
  const [val, setVal] = useState("");

  const start = (e) => { e.stopPropagation(); setVal(String(Math.round(value))); setEdit(true); };
  const commit = () => {
    setEdit(false);
    if (val === String(Math.round(value))) return;
    if (val !== "" && (isNaN(Number(val)) || Number(val) < 0)) return;
    onSave(val === "" ? null : Number(val));
  };

  if (edit) {
    return (
      <input autoFocus type="number" min="0" value={val} onClick={(e) => e.stopPropagation()}
        onChange={(e) => setVal(e.target.value)} onBlur={commit}
        onKeyDown={(e) => { if (e.key === "Enter") e.currentTarget.blur(); if (e.key === "Escape") { setVal(String(Math.round(value))); setEdit(false); } }}
        className="w-[58px] mx-auto h-7 text-sm text-center border border-primary rounded bg-background" data-testid={`${testid}-input`}/>
    );
  }
  return (
    <span role="button" tabIndex={0} onClick={start} title="Klicken zum Ändern (leer = Tagespreis entfernen)"
      className="flex flex-col items-center rounded hover:bg-primary/10 cursor-text px-1" data-testid={testid}>
      <span className={`text-sm ${bold ? "font-bold text-primary" : "font-medium"}`}>{Math.round(value)} €</span>
      <span className="text-[9px] text-muted-foreground truncate max-w-[62px]">{rule.replace("Saison: ", "").replace("Tagespreis ab", "Tag ab")}</span>
    </span>
  );
};
